/* global jQuery */

import GA4Tracking from './utils/ga4-tracking'
import {getCheckoutItems, getShippingText} from 'app/GA4/utils/_ga4-tracking-checkout'

export const handleAddShippingInfoEvent = () => {
  jQuery('form.checkout').on( 'checkout_place_order_success', () => {
    const checkoutItems = getCheckoutItems()
    const shippingText = getShippingText()

    if (checkoutItems !== null && typeof shippingText === 'string') {
      GA4Tracking.pushEvent('add_shipping_info', checkoutItems, {shipping_tier: shippingText})
    }

    return true // return true to continue the submission
  })
}
